import { render, staticRenderFns } from "./modalManage.vue?vue&type=template&id=393b288d&scoped=true&"
import script from "./modalManage.vue?vue&type=script&lang=js&"
export * from "./modalManage.vue?vue&type=script&lang=js&"
import style0 from "./modalManage.vue?vue&type=style&index=0&id=393b288d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393b288d",
  null
  
)

export default component.exports